export default __webpack_public_path__ + "static/media/breakfast.1a2fc3e8.jpg";